import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import { Controller } from 'react-hook-form';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { IExperimentFormInput } from '../interfaces';
import styles from './index.module.scss';

const ExperimentFormTextInput = (props: IExperimentFormInput) => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled = false,
    inputLabel,
    placeholder,
    showRequiredIcon = false,
    containerClass
  } = props;

  return (
    <>
      <div className={cx('flex items-center', containerClass)}>
        <Typography color="var(--grayscale-2)" variant={'p4'}>
          {inputLabel}
          {showRequiredIcon ? <RequiredIcon className="mb-1 ml-1" /> : null}
        </Typography>
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, onBlur } }) => (
          <BorderedInput
            placeholder={placeholder}
            fullWidth
            onChange={onChange}
            value={value}
            disabled={isEditDisabled}
            onBlur={onBlur}
          />
        )}
      />
      {errors?.[name]?.message && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {errors?.[name]?.message}
          </Typography>
        </div>
      )}
    </>
  );
};

export default ExperimentFormTextInput;
